// Module
var code = `<div class="svc-tabbed-menu">
  <!-- ko foreach: renderedActions -->
  <span class="svc-tabbed-menu-item-container" data-bind="css: { 'sv-action--hidden': !isVisible }, class: \$data.css">
    <div class="sv-action__content">
    <!-- ko component: { name: \$data.component || 'svc-tabbed-menu-item', params: { item: \$data } } -->
    <!-- /ko -->
    </div>
  </span>
  <!-- /ko -->
</div>
`;
// Exports
export default code;